import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import type { DropCallback } from '../../../stores/types/user-interface';
import { DRAG_TYPE } from '../../../stores/reducers/user-interface';
import useDropArea from '../../../hooks/use-dnd/use-drop-area';
import { GreenroomState as GS } from '../../../stores/types/types';
import { useLivekit } from '../../../contexts/livekit/livekit-context';
import DefaultSafetyImage from '../../../images/default-safety-image.png';

interface Props {
	feedPosition: number;
	ingressStreamId: string;
	dropCallback: DropCallback;
	isSpotlightFeed?: boolean;
}

export default function FeedIngressStream(props: Props) {
	const { feedPosition, ingressStreamId, dropCallback, isSpotlightFeed = false } = props;

	const ingressSessions = useSelector((s: GS) => s.LivekitReducer.livekitIngresses);
	const session = ingressSessions.find((s) => s.id === ingressStreamId);

	const { tracksMap } = useLivekit();
	const videoTrack = session
		? ((session.participantIdentity ? tracksMap.get(session.participantIdentity) : undefined)
			?? (session.participantIdentity ? tracksMap.get(session.participantIdentity) : undefined)
			?? null)
		: null;

	const videoRef = useRef<HTMLVideoElement>(null);

	const { isOver, dropRef } = useDropArea({
		accepts: DRAG_TYPE.FEEDS,
		dropCallback,
		dropAreaData: { feedPosition },
	});

	useEffect(() => {
		if (!videoRef.current || !videoTrack) return;
		videoTrack.attach(videoRef.current);
		return () => {
			videoTrack.detach(videoRef.current!);
		};
	}, [videoTrack]);

	return (
		<>
			{isOver && <div className="dnd-highlighted" />}
			<div className="media" ref={dropRef}>
				<div className="flex-center height-full width-full">
					{videoTrack ? (
						<video
							ref={videoRef}
							autoPlay
							playsInline
							muted
							className="media-video"
						/>
					) : (
						<img
							className="media-img"
							src={DefaultSafetyImage}
							alt="Safety Image"
						/>
					)}
				</div>
			</div>
		</>
	);
}